module.exports = __webpack_public_path__ + "img/img_comercial4.d94a0dd7.png";